<script>
	import { Router, Route, navigate } from "svelte-routing";

	import { model } from "./stores";

	import RegistrationLandingPage from "./routes/Registration/LandingPage.svelte";
	import PersonalDetails from "./routes/Registration/PersonalDetails.svelte";
	import Details from "./routes/Registration/Details.svelte";
	import Confirmation from "./routes/Registration/Confirmation.svelte";
	import Review from "./routes/Registration/Review.svelte";
	import RegistrationThankYou from "./routes/Registration/ThankYou.svelte";

	import FileUploadLandingPage from "./routes/FileUpload/LandingPage.svelte";
	import Files from "./routes/FileUpload/Files.svelte";
	import FileUploadThankYou from "./routes/FileUpload/ThankYou.svelte";

	import ConfirmAgreementsLandingPage from "./routes/ConfirmAgreements/LandingPage.svelte";
	import ConfirmAgreements from "./routes/ConfirmAgreements/ConfirmAgreements.svelte";
	import ConfirmAgreementsThankYou from "./routes/ConfirmAgreements/ThankYou.svelte";

	import AmendmentsLandingPage from "./routes/AcknowledgeAmendments/LandingPage.svelte";
	import AmendmentsLetter from "./routes/AcknowledgeAmendments/Letter.svelte";
	import AmendmentsFunding from "./routes/AcknowledgeAmendments/Funding.svelte";
	import AmendmentsDisclosure from "./routes/AcknowledgeAmendments/Disclosure.svelte";
	import AmendmentsThankYou from "./routes/AcknowledgeAmendments/ThankYou.svelte";

	import AcknowledgeUpdatedAgreementsLandingPage from "./routes/AcknowledgeUpdatedAgreements/LandingPage.svelte";
	import AcknowledgeUpdatedAgreementsLetter from "./routes/AcknowledgeUpdatedAgreements/Letter.svelte";
	import AcknowledgeUpdatedAgreementsThankYou from "./routes/AcknowledgeUpdatedAgreements/ThankYou.svelte";

	import AgreementsAcceptanceLandingPage from "./routes/AgreementsAcceptance/LandingPage.svelte";
	import AgreementsAcceptanceCost from "./routes/AgreementsAcceptance/Cost.svelte";
	import AgreementsAcceptanceFunding from "./routes/AgreementsAcceptance/Funding.svelte";
	import AgreementsAcceptanceThankYou from "./routes/AgreementsAcceptance/ThankYou.svelte";

	import QuestionnaireQuestions from "./routes/Questionnaire/Questions.svelte";
	import QuestionnaireConfirmation from "./routes/Questionnaire/Confirmation.svelte";
	import QuestionnaireThankYou from "./routes/Questionnaire/ThankYou.svelte";
	import QuestionnaireReview from "./routes/Questionnaire/Review.svelte";

	import QuestionnaireQuestions2 from "./routes/Questionnaire2/Questions.svelte";
	import QuestionnaireConfirmation2 from "./routes/Questionnaire2/Confirmation.svelte";
	import QuestionnaireThankYou2 from "./routes/Questionnaire2/ThankYou.svelte";
	import QuestionnaireReview2 from "./routes/Questionnaire2/Review.svelte";

	import Error from "./routes/Error.svelte";
	import NavTracker from "./components/NavTracker.svelte";
	import { regFormPhone } from "./tealium";

	import { applicationPages, projectSettings } from "./config";

	export let url = "";
	const basepath = "/";
	const copyrightYear = document.copyrightYear || "2024";

	let pageList = null;
	let pageIndex = null;
	let applicationSection = null;

	const disableSubmitOnEnter = (e) => {
		if (e.which != "13") return;

		if (e.target && e.target.type && e.target.type != "textarea") {
			e.preventDefault();
		}
	};

	const checkLandingUrl = function () {
		// console.log("checkLandingUrl", window.location.pathname);

		if (window.location.pathname.indexOf("/FileUpload") >= 0 && window.location.pathname !== "/FileUpload") {
			window.location.href = "/FileUpload";
			return false;
		} else if (
			window.location.pathname.indexOf("/QuestionnaireReview2") >= 0 &&
			window.location.pathname !== "/QuestionnaireReview2"
		) {
			navigate("/Questionnaire2/Questions");
			return false;
		} else if (
			window.location.pathname.indexOf("/Questionnaire2") >= 0 &&
			window.location.pathname !== "/Questionnaire2" &&
			window.location.pathname !== "/QuestionnaireReview2"
		) {
			navigate("/Questionnaire2/Questions");
			return false;
		} else if (
			window.location.pathname.indexOf("/QuestionnaireReview") >= 0 &&
			window.location.pathname !== "/QuestionnaireReview" &&
			window.location.pathname !== "/QuestionnaireReview2"
		) {
			navigate("/Questionnaire/Questions");
			return false;
		} else if (
			window.location.pathname.indexOf("/Questionnaire") >= 0 &&
			window.location.pathname !== "/Questionnaire" &&
			window.location.pathname !== "/Questionnaire2" &&
			window.location.pathname !== "/QuestionnaireReview" &&
			window.location.pathname !== "/QuestionnaireReview2"
		) {
			navigate("/Questionnaire/Questions");
			return false;
		} else if (
			window.location.pathname.indexOf("/AcknowledgeAmendments") >= 0 &&
			window.location.pathname !== "/AcknowledgeAmendments"
		) {
			navigate("/AcknowledgeAmendments");
			return false;
		} else if (
			window.location.pathname.indexOf("/AcknowledgeUpdatedAgreements") >= 0 &&
			window.location.pathname !== "/AcknowledgeUpdatedAgreements"
		) {
			navigate("/AcknowledgeUpdatedAgreements");
			return false;
		} else if (
			window.location.pathname.indexOf("/AgreementsAcceptance") >= 0 &&
			window.location.pathname !== "/AgreementsAcceptance"
		) {
			navigate("/AgreementsAcceptance");
			return false;
		} else if (
			window.location.pathname.indexOf("/ConfirmAgreements") >= 0 &&
			window.location.pathname !== "/ConfirmAgreements"
		) {
			window.location.href = "/ConfirmAgreements";
			return false;
		} else if (
			window.location.pathname.indexOf("/Registration") >= 0 &&
			window.location.pathname !== "/Registration"
		) {
			console.log;
			window.location.href = "/Registration";
			return false;
		} else if (
			window.location.pathname.indexOf("/Registration") < 0 &&
			window.location.pathname.indexOf("/Questionnaire2") < 0 &&
			window.location.pathname.indexOf("/QuestionnaireReview2") < 0 &&
			window.location.pathname.indexOf("/Questionnaire") < 0 &&
			window.location.pathname.indexOf("/QuestionnaireReview") < 0 &&
			window.location.pathname.indexOf("/AcknowledgeAmendments") < 0 &&
			window.location.pathname.indexOf("/AcknowledgeUpdatedAgreements") < 0 &&
			window.location.pathname.indexOf("/AgreementsAcceptance") < 0 &&
			window.location.pathname.indexOf("/ConfirmAgreements") < 0 &&
			window.location.pathname.indexOf("/FileUpload") < 0 &&
			window.location.pathname.indexOf("/Review") < 0
		) {
			window.location.href = "/Registration";
			return false;
		}

		if (window.location.pathname === "/FileUpload") {
			applicationSection = "FileUpload";
			pageList = applicationPages.fileUploadPageList;
			pageIndex = applicationPages.fileUploadPageIndex;
		} else if (window.location.pathname === "/QuestionnaireReview2") {
			applicationSection = "QuestionnaireReview2";
			pageList = applicationPages.questionnaire2PageList;
			pageIndex = applicationPages.questionnaire2PageIndex;
			console.log("QuestionnaireReview2");
			navigate("/Questionnaire2/Review");
		} else if (window.location.pathname === "/Questionnaire2") {
			console.log("Questionnaire2");
			applicationSection = "Questionnaire2";
			pageList = applicationPages.questionnaire2PageList;
			pageIndex = applicationPages.questionnaire2PageIndex;
		} else if (window.location.pathname === "/QuestionnaireReview") {
			applicationSection = "QuestionnaireReview";
			pageList = applicationPages.questionnairePageList;
			pageIndex = applicationPages.questionnairePageIndex;
			console.log("QuestionnaireReview");
			navigate("/Questionnaire/Review");
		} else if (window.location.pathname === "/Questionnaire") {
			console.log("Questionnaire");
			applicationSection = "Questionnaire";
			pageList = applicationPages.questionnairePageList;
			pageIndex = applicationPages.questionnairePageIndex;
		} else if (window.location.pathname === "/ConfirmAgreements") {
			applicationSection = "ConfirmAgreements";
			pageList = applicationPages.confirmAgreementsPageList;
			pageIndex = applicationPages.confirmAgreementsPageIndex;
		} else if (window.location.pathname === "/AcknowledgeAmendments") {
			applicationSection = "AcknowledgeAmendments";
			pageList =
				$model.AcknowledgementType == "AU"
					? applicationPages.acknowledgeAmendmentsPageListAU
					: applicationPages.acknowledgeAmendmentsPageListOS;
			pageIndex =
				$model.AcknowledgementType == "AU"
					? applicationPages.acknowledgeAmendmentsPageIndexAU
					: applicationPages.acknowledgeAmendmentsPageListAU;
		} else if (window.location.pathname === "/AcknowledgeUpdatedAgreements") {
			applicationSection = "AcknowledgeUpdatedAgreements";
			pageList = applicationPages.acknowledgeUpdatedAgreementsPageList;
			pageIndex = applicationPages.acknowledgeUpdatedAgreementsPageIndex;
		} else if (window.location.pathname === "/AgreementsAcceptance") {
			applicationSection = "AgreementsAcceptance";
			pageList = applicationPages.agreementsAcceptancePageList;
			pageIndex = applicationPages.agreementsAcceptancePageIndex;
		} else {
			applicationSection = "Registration";
			pageList = applicationPages.registrationPageList;
			pageIndex = applicationPages.registrationPageIndex;
			console.log("Registration");
		}

		return true;
	};

	if (checkLandingUrl()) {
		window.onbeforeunload = (event) => {
			event.returnValue = `Are you sure you want to leave?`;
		};

		if (window.location.pathname === "/FileUpload" && window.location.search) {
			navigate("/FileUpload", { replace: true });
		} else if (window.location.pathname === "/ConfirmAgreements" && window.location.search) {
			if ($model.AgreementsConfirmed) {
				navigate("/ConfirmAgreements/Thankyou", { replace: true });
			} else {
				navigate("/ConfirmAgreements", { replace: true });
			}
		} else if (window.location.pathname === "/AcknowledgeAmendments" && window.location.search) {
			if ($model.AcknowledgeLetter) {
				navigate("/AcknowledgeAmendments/Thankyou", { replace: true });
			} else {
				navigate("/AcknowledgeAmendments", { replace: true });
			}
		} else if (window.location.pathname === "/AcknowledgeUpdatedAgreements" && window.location.search) {
			if ($model.AcknowledgeLetterAUG22) {
				navigate("/AcknowledgeUpdatedAgreements/Thankyou", { replace: true });
			} else {
				navigate("/AcknowledgeUpdatedAgreements", { replace: true });
			}
		} else if (window.location.pathname === "/AgreementsAcceptance" && window.location.search) {
			if ($model.CostAgreementConfirmed && $model.LFAConfirmed) {
				navigate("/AgreementsAcceptance/Thankyou", { replace: true });
			} else {
				navigate("/AgreementsAcceptance", { replace: true });
			}
		}
	}
</script>

<svelte:head>
	<!-- Google Tag Manager -->
	<script>
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-TW92CF2W");
	</script>
	<!-- End Google Tag Manager -->
</svelte:head>

<div class="page-container" on:keypress={(e) => disableSubmitOnEnter(e)}>
	<header>
		<div class="page-header">
			<img class="logo" src="/img/logo.png" alt="Shine Lawyers" />
			<div class="phone">
				<a
					target="_blank"
					href="tel:{projectSettings.phoneNumber}"
					title="Call {projectSettings.phoneNumber}"
					on:click={() => regFormPhone(projectSettings.phoneNumber)}
				>
					<div class="phone-container">
						<svg class="phone-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
							<g>
								<path
									vector-effect="non-scaling-stroke"
									d="M19.33,16.26c0.01-0.07,0.01-0.15,0-0.22c-0.21-0.25-0.48-0.44-0.79-0.55l-0.56-0.31l-0.66-0.36l-0.56-0.32  l-0.26-0.18c-0.12-0.08-0.24-0.16-0.37-0.22c-0.1-0.06-0.21-0.09-0.33-0.09c-0.2,0.03-0.39,0.14-0.52,0.3  c-0.21,0.2-0.4,0.42-0.57,0.65c-0.17,0.23-0.35,0.45-0.55,0.65c-0.12,0.16-0.29,0.26-0.48,0.3c-0.08,0-0.16-0.02-0.23-0.05  l-0.21-0.09L13,15.61l-0.2-0.12c-0.9-0.49-1.72-1.1-2.45-1.81c-0.71-0.73-1.32-1.55-1.81-2.45L8.4,11.01l-0.15-0.25  c-0.03-0.07-0.06-0.14-0.09-0.21c-0.03-0.07-0.05-0.15-0.05-0.23c0.04-0.19,0.14-0.36,0.3-0.48c0.2-0.2,0.42-0.38,0.65-0.55  C9.29,9.12,9.5,8.93,9.7,8.73C9.86,8.6,9.97,8.41,10,8.21c0-0.1-0.02-0.21-0.07-0.3C9.86,7.78,9.79,7.66,9.7,7.54L9.52,7.28  L9.2,6.73L8.83,6.07L8.52,5.5C8.42,5.2,8.24,4.92,8,4.71c-0.07-0.01-0.15-0.01-0.22,0c-0.25,0.01-0.49,0.04-0.73,0.1  C6.79,4.85,6.54,4.92,6.3,5.01c-0.49,0.3-0.87,0.74-1.1,1.26C4.86,6.86,4.68,7.53,4.67,8.21c-0.01,0.18-0.01,0.37,0,0.55  c0.03,0.2,0.07,0.4,0.13,0.6C4.89,9.58,4.95,9.74,5,9.85l0.2,0.58l0.19,0.51c0.22,0.64,0.51,1.25,0.86,1.82  c0.64,1,1.4,1.92,2.25,2.75c0.83,0.85,1.75,1.61,2.75,2.25c0.57,0.35,1.18,0.64,1.82,0.86l0.51,0.19l0.58,0.2l0.49,0.15  c0.2,0.06,0.4,0.1,0.6,0.13c0.18,0.01,0.37,0.01,0.55,0c0.68-0.01,1.35-0.19,1.94-0.53c0.52-0.22,0.95-0.58,1.26-1.05  c0.1-0.23,0.17-0.46,0.23-0.7c0.06-0.24,0.09-0.48,0.1-0.73l0,0V16.26z"
									style="fill: rgb(21, 171, 166);"
								></path>
							</g>
						</svg>
						<div class="phone-number">{projectSettings.phoneNumber}</div>
					</div>
				</a>
			</div>
		</div>
	</header>
	<div class="content-wrap container" style="padding: 40px;">
		<Router {url} {basepath}>
			<div>
				<NavTracker {pageList} />
				<Route path="/">
					<RegistrationLandingPage {...pageList[pageIndex.LandingPage]}></RegistrationLandingPage>
				</Route>
				<Route path="Registration">
					<RegistrationLandingPage {...pageList[pageIndex.LandingPage]}></RegistrationLandingPage>
				</Route>
				<Route path="Registration/PersonalDetails">
					<PersonalDetails {...pageList[pageIndex.PersonalDetails]}></PersonalDetails>
				</Route>
				<Route path="Registration/Details">
					<Details {...pageList[pageIndex.Details]}></Details>
				</Route>
				<Route path="Registration/Confirmation">
					<Confirmation {...pageList[pageIndex.Confirmation]}></Confirmation>
				</Route>
				<Route path="Registration/ThankYou">
					<RegistrationThankYou {...pageList[pageIndex.ThankYou]}></RegistrationThankYou>
				</Route>

				<Route path="FileUpload">
					<FileUploadLandingPage {...pageList[pageIndex.FileUploadLandingPage]}></FileUploadLandingPage>
				</Route>
				<Route path="FileUpload/Files">
					<Files {...pageList[pageIndex.FileUploadFiles]}></Files>
				</Route>
				<Route path="FileUpload/Thankyou">
					<FileUploadThankYou {...pageList[pageIndex.FileUploadThankYou]}></FileUploadThankYou>
				</Route>

				<Route path="ConfirmAgreements">
					<ConfirmAgreementsLandingPage {...pageList[pageIndex.ConfirmAgreements_LandingPage]}
					></ConfirmAgreementsLandingPage>
				</Route>
				<Route path="ConfirmAgreements/Confirm">
					<ConfirmAgreements {...pageList[pageIndex.ConfirmAgreements_CostAndFundingAgreements]}
					></ConfirmAgreements>
				</Route>
				<Route path="ConfirmAgreements/Thankyou">
					<ConfirmAgreementsThankYou {...pageList[pageIndex.ConfirmAgreements_ThankYou]}
					></ConfirmAgreementsThankYou>
				</Route>

				<Route path="AcknowledgeAmendments">
					<AmendmentsLandingPage {...pageList[0]}></AmendmentsLandingPage>
				</Route>
				<Route path="AcknowledgeAmendments/Letter">
					<AmendmentsLetter {...pageList[1]}></AmendmentsLetter>
				</Route>
				<Route path="AcknowledgeAmendments/Funding">
					<AmendmentsFunding {...pageList[2]}></AmendmentsFunding>
				</Route>
				<Route path="AcknowledgeAmendments/Disclosure">
					<AmendmentsDisclosure {...pageList[3]}></AmendmentsDisclosure>
				</Route>
				<Route path="AcknowledgeAmendments/Thankyou">
					<AmendmentsThankYou {...pageList[4]}></AmendmentsThankYou>
				</Route>

				<Route path="AcknowledgeUpdatedAgreements">
					<AcknowledgeUpdatedAgreementsLandingPage {...pageList[0]}></AcknowledgeUpdatedAgreementsLandingPage>
				</Route>
				<Route path="AcknowledgeUpdatedAgreements/Letter">
					<AcknowledgeUpdatedAgreementsLetter {...pageList[1]}></AcknowledgeUpdatedAgreementsLetter>
				</Route>
				<Route path="AcknowledgeUpdatedAgreements/Thankyou">
					<AcknowledgeUpdatedAgreementsThankYou {...pageList[2]}></AcknowledgeUpdatedAgreementsThankYou>
				</Route>

				<Route path="AgreementsAcceptance">
					<AgreementsAcceptanceLandingPage {...pageList[0]}></AgreementsAcceptanceLandingPage>
				</Route>
				<Route path="AgreementsAcceptance/Cost">
					<AgreementsAcceptanceCost {...pageList[1]}></AgreementsAcceptanceCost>
				</Route>
				<Route path="AgreementsAcceptance/Funding">
					<AgreementsAcceptanceFunding {...pageList[2]}></AgreementsAcceptanceFunding>
				</Route>
				<Route path="AgreementsAcceptance/Thankyou">
					<AgreementsAcceptanceThankYou {...pageList[3]}></AgreementsAcceptanceThankYou>
				</Route>

				<Route path="Questionnaire">
					<QuestionnaireQuestions {...pageList[0]}></QuestionnaireQuestions>
				</Route>
				<Route path="Questionnaire/Questions">
					<QuestionnaireQuestions {...pageList[0]}></QuestionnaireQuestions>
				</Route>
				<Route path="Questionnaire/Confirmation">
					<QuestionnaireConfirmation {...pageList[1]}></QuestionnaireConfirmation>
				</Route>
				<Route path="Questionnaire/ThankYou">
					<QuestionnaireThankYou {...pageList[2]}></QuestionnaireThankYou>
				</Route>
				<Route path="QuestionnaireReview">
					<QuestionnaireReview {...pageList[3]}></QuestionnaireReview>
				</Route>
				<Route path="Questionnaire/Review">
					<QuestionnaireReview {...pageList[3]}></QuestionnaireReview>
				</Route>

				<Route path="Questionnaire2">
					<QuestionnaireQuestions2 {...pageList[0]}></QuestionnaireQuestions2>
				</Route>
				<Route path="Questionnaire2/Questions">
					<QuestionnaireQuestions2 {...pageList[0]}></QuestionnaireQuestions2>
				</Route>
				<Route path="Questionnaire2/Confirmation">
					<QuestionnaireConfirmation2 {...pageList[1]}></QuestionnaireConfirmation2>
				</Route>
				<Route path="Questionnaire2/ThankYou">
					<QuestionnaireThankYou2 {...pageList[2]}></QuestionnaireThankYou2>
				</Route>
				<Route path="QuestionnaireReview2">
					<QuestionnaireReview2 {...pageList[3]}></QuestionnaireReview2>
				</Route>
				<Route path="Questionnaire2/Review">
					<QuestionnaireReview2 {...pageList[3]}></QuestionnaireReview2>
				</Route>

				<Route path="Review" component={Review} />
				<Route path="*/Error" component={Error} />
			</div>
		</Router>
	</div>
</div>

<span class="build-id-tag">$(CAMS_BuildId)</span>

<footer>
	<div class="page-footer">
		<img class="logo" src="/img/logo.png" alt="Shine Lawyers" />
		<p class="copyright">&copy; Copyright {copyrightYear} Shine Lawyers. All Rights Reserved.</p>
	</div>
</footer>

<style>
	.build-id-tag {
		color: #252525;
		position: absolute;
		top: 10px;
		right: 10px;
		font-size: 8px;
	}

	body footer,
	body header {
		padding-top: 0;
	}

	header {
		color: #ffffff;
		background-color: #252525;
	}

	header .page-header {
		height: 155px;
		margin: 0 auto;
		display: flex;
		max-width: 80%;
		align-items: center;
		justify-content: space-between;
	}

	header .logo {
		width: 50%;
	}

	header .phone {
		display: flex;
		align-items: center;
		position: relative;
		top: 10px;
	}

	header .phone a {
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		flex-direction: column;
		position: relative;
		height: 100%;
		min-width: fit-content;
		color: var(--color-primary);
	}

	header .phone a .phone-container {
		display: flex;
		align-items: center;
		top: 10px;
	}

	header .phone-icon {
		width: 48px;
		height: 50px;
		fill: currentColor;
		display: inline-block;
		font-size: 1.2857142857142856rem;
		transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
		flex-shrink: 0;
		user-select: none;
	}

	header .phone-number {
		margin-left: 8px;
		font-size: 18px;
		font-family: arial;
		font-weight: 400;
		line-height: 1.5;
	}

	.page-container {
		min-height: calc(100vh - 155px);
	}

	footer {
		width: 100%;
		color: #ffffff;
		background-color: #252525;
	}

	footer .logo {
		width: 50%;
	}

	footer .page-footer {
		height: 155px;
		margin: 0 auto;
		display: flex;
		max-width: 80%;
		align-items: center;
		justify-content: space-between;
	}

	footer .copyright {
		position: inherit;
		font-size: 13px;
		margin-left: 10%;
		text-align: center;
	}

	@media (min-width: 768px) {
		header .logo,
		footer .logo {
			width: 300px;
		}

		header .phone {
			display: flex;
			align-items: center;
			position: inherit;
		}
	}

	@media (min-width: 992px) {
		footer .copyright {
			left: 50%;
			position: absolute;
			font-size: 13px;
			transform: translate(-50%, 0);
			font-family: arial;
			font-weight: 400;
			line-height: 1.5;
		}
	}
</style>
